import { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { actions } from "../store/reducers/authentication";
import StorageManager from "./StorageManager";

export default () => {
  const token = useMemo(() => StorageManager.get("TOKEN"), []);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.fetchUser(token, (err) => toast.error(err)));
  }, []);
};
